// react
import React, { useState, useEffect } from 'react';

// third-party
import { Helmet } from 'react-helmet-async';
import { Link, useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

// application
import PageHeader from '../shared/PageHeader';

// data stubs
import theme from '../../data/theme';

export default function Registration() {
  const history = useHistory();
  const { search } = useLocation();

  const queryParams = new URLSearchParams(search);
  const key = queryParams.get('key') || (search.includes('=') ? search.split('=')[1] : '');

  const [username, setUsername] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [address, setAddress] = useState('');
  const [load, setLoad] = useState(false);
  const [gender, setGender] = useState('');
  const [province, setProvince] = useState('');
  const [city, setCity] = useState('');
  const [district, setDistrict] = useState('');
  const [village, setVillage] = useState('');
  const [phone, setPhone] = useState('');
  const [refferal_code, setRefferalCode] = useState('');

  const [provinceData, setProvinceData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [kecamatans, setKecamatans] = useState([]);
  const [desas, setDesas] = useState([]);

  const breadcrumb = [
    { title: 'Home', url: '/' },
    { title: 'Akun', url: '/account' },
    { title: 'Pendaftaran Akun', url: '' },
  ];

  const regist = async (e) => {
    e.preventDefault();
    const body = {
      username,
      name,
      email,
      password,
      gender,
      address,
      city,
      province,
      phone,
      refferal_code,
      district,
      village,
    };

    try {
      if (
        !username ||
        !name ||
        !password ||
        !email ||
        !phone ||
        !address ||
        !gender ||
        !district ||
        !village ||
        !province ||
        !city
      ) {
        toast.error('Harap isi semua kolom bertanda wajib!');
      } else {
        setLoad(true);
        await axios.post(
          `${process.env.REACT_APP_HOST_API}/auth/register?key=${key}`,
          body
        );
        setLoad(false);
        toast.success('Pendaftaran akun berhasil! Silakan masuk.');
        history.push('/account/login');
      }
    } catch (error) {
      setLoad(false);
      let errorMsg =
        error.code === 'ERR_NETWORK'
          ? 'Koneksi jaringan terputus'
          : error.response
          ? error.response.data?.message || error.response.data?.error || 'Pendaftaran gagal'
          : 'Terjadi kesalahan sistem';
      toast.error(errorMsg);
    }
  };

  useEffect(() => {
    const getProvince = async () => {
      try {
        const result = await axios.get(
          `${process.env.REACT_APP_HOST_API}/province/list`
        );
        setProvinceData(result.data?.response || []);
      } catch (error) {
        console.error(error);
      }
    };

    getProvince();
  }, []);

  useEffect(() => {
    const getCity = async () => {
      if (!province) return;
      try {
        const result = await axios.get(
          `${process.env.REACT_APP_HOST_API}/city/listing?province_id=${province}`
        );
        setCityData(result.data?.response || []);
      } catch (error) {
        console.error(error);
      }
    };

    getCity();
  }, [province]);

  useEffect(() => {
    const getKecamatan = async () => {
      if (!city) return;
      try {
        const result = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_HOST_API}/district/listing?city_id=${city}`,
        });
        setKecamatans(result.data?.response || []);
      } catch (error) {
        console.error(error);
      }
    };

    getKecamatan();
  }, [city]);

  useEffect(() => {
    const getDesa = async () => {
      if (!district) return;
      try {
        const result = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_HOST_API}/village/listing?district_id=${district}`,
        });
        setDesas(result.data?.response || []);
      } catch (error) {
        console.error(error);
      }
    };

    getDesa();
  }, [district]);

  useEffect(() => {
    if (key) {
      axios
        .get(`${process.env.REACT_APP_HOST_API}/auth/email-info?key=${key}`)
        .then((data) => {
          if (data.data?.response) {
            setEmail(data.data.response);
          }
        })
        .catch((error) => {
          console.error('Error fetching email by key:', error);
        });
    }
  }, [key]);

  const handleProvinceChange = (e) => {
    setProvince(e.target.value);
    setCity('');
    setDistrict('');
    setVillage('');
    setCityData([]);
    setKecamatans([]);
    setDesas([]);
  };

  const handleCityChange = (e) => {
    setCity(e.target.value);
    setDistrict('');
    setVillage('');
    setKecamatans([]);
    setDesas([]);
  };

  const handleDistrictChange = (e) => {
    setDistrict(e.target.value);
    setVillage('');
    setDesas([]);
  };

  const field = (id, label, icon, input, isRequired = true, extraClass = '') => (
    <div className={`auth-form-group ${extraClass}`}>
      <label htmlFor={id}>
        {label} {isRequired && <span className="text-danger">*</span>}
      </label>
      <div className="auth-input-wrapper">
        <i className={`${icon} input-icon-left`} />
        {input}
      </div>
    </div>
  );

  const selectField = (id, label, icon, value, onChange, placeholder, list, disabled, isRequired = true, extraClass = '') =>
    field(
      id,
      label,
      icon,
      <select
        id={id}
        className="auth-input auth-select"
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {Array.isArray(list) &&
          list.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
      </select>,
      isRequired,
      extraClass
    );

  return (
    <React.Fragment>
      <Helmet>
        <title>{`Lengkapi Pendaftaran Akun | ${theme.name}`}</title>
      </Helmet>

      <div className="hokky-auth-page-block">
        <PageHeader breadcrumb={breadcrumb} />

        <div className="container hokky-auth-main-container">
          <div className="hokky-auth-container hokky-auth-container--wide">
            <div className="hokky-auth-card">
              <div className="hokky-auth-header">
                <img
                  src={`${process.env.PUBLIC_URL || ''}/images/logo-footer.png`}
                  alt="Hokky Bangunan"
                  className="auth-brand-logo"
                />
                <h2 className="auth-title">Lengkapi Pendaftaran Akun</h2>
                <p className="auth-subtitle">
                  Satu langkah lagi untuk menikmati kemudahan belanja bahan bangunan terlengkap dan termurah.
                </p>
              </div>

              {email && (
                <div className="auth-verified-notice">
                  <div className="notice-icon">
                    <i className="fas fa-check-circle" />
                  </div>
                  <div className="notice-content">
                    <span className="notice-label">Email Terverifikasi</span>
                    <span className="notice-email">{email}</span>
                  </div>
                </div>
              )}

              <form className="hokky-auth-form" onSubmit={regist}>
                {/* Section 1: Informasi Akun */}
                <div className="auth-section-header">
                  <div className="auth-section-icon-box">
                    <i className="fas fa-user-circle" />
                  </div>
                  <div>
                    <h3 className="auth-section-title">Informasi Akun</h3>
                    <span className="auth-section-desc">Data login dan identitas akun Anda</span>
                  </div>
                </div>

                <div className="auth-grid">
                  {field(
                    'username',
                    'Username',
                    'far fa-user',
                    <input
                      id="username"
                      type="text"
                      className="auth-input"
                      placeholder="Contoh: faisal_hidayat"
                      value={username}
                      onChange={(e) => setUsername(e.target.value.toLowerCase().replace(/\s+/g, ''))}
                      autoComplete="username"
                    />
                  )}

                  {field(
                    'name',
                    'Nama Lengkap',
                    'far fa-id-badge',
                    <input
                      id="name"
                      type="text"
                      className="auth-input"
                      placeholder="Nama lengkap sesuai KTP"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      autoComplete="name"
                    />
                  )}

                  {field(
                    'register-email',
                    'Alamat Email',
                    'far fa-envelope',
                    <React.Fragment>
                      <input
                        id="register-email"
                        type="email"
                        className="auth-input"
                        value={email}
                        placeholder="Memuat email..."
                        disabled
                        readOnly
                      />
                      {email && (
                        <span className="auth-input-verified-tag">
                          <i className="fas fa-check-circle mr-1" /> Terverifikasi
                        </span>
                      )}
                    </React.Fragment>
                  )}

                  <div className="auth-form-group">
                    <label htmlFor="register-password">
                      Kata Sandi <span className="text-danger">*</span>
                    </label>
                    <div className="auth-input-wrapper">
                      <i className="fas fa-lock input-icon-left" />
                      <input
                        id="register-password"
                        type={showPassword ? 'text' : 'password'}
                        className="auth-input"
                        placeholder="Minimal 6 karakter"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password"
                      />
                      <button
                        type="button"
                        className="auth-password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                        aria-label={showPassword ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi'}
                      >
                        <i className={`far ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                      </button>
                    </div>
                  </div>

                  {field(
                    'phoneNumber',
                    'No. Handphone / WhatsApp',
                    'fas fa-phone-alt',
                    <input
                      id="phoneNumber"
                      type="tel"
                      className="auth-input"
                      placeholder="Contoh: 081230553236"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      autoComplete="tel"
                    />
                  )}

                  {selectField(
                    'gender',
                    'Jenis Kelamin',
                    'fas fa-venus-mars',
                    gender || '',
                    (e) => setGender(e.target.value),
                    'Pilih jenis kelamin',
                    [
                      { id: 1, name: 'Laki-Laki' },
                      { id: 2, name: 'Perempuan' },
                    ]
                  )}

                  {field(
                    'referral',
                    'Kode Referral (Opsional)',
                    'fas fa-gift',
                    <input
                      id="referral"
                      type="text"
                      className="auth-input"
                      placeholder="Masukkan kode referral jika ada"
                      value={refferal_code}
                      onChange={(e) => setRefferalCode(e.target.value)}
                    />,
                    false,
                    'auth-grid-full'
                  )}
                </div>

                {/* Section 2: Alamat Pengiriman */}
                <div className="auth-section-header">
                  <div className="auth-section-icon-box">
                    <i className="fas fa-map-marked-alt" />
                  </div>
                  <div>
                    <h3 className="auth-section-title">Alamat Pengiriman Utama</h3>
                    <span className="auth-section-desc">Lokasi tujuan pengiriman pesanan bahan bangunan Anda</span>
                  </div>
                </div>

                <div className="auth-grid">
                  {selectField(
                    'province',
                    'Provinsi',
                    'fas fa-map',
                    province,
                    handleProvinceChange,
                    'Pilih provinsi',
                    provinceData
                  )}

                  {selectField(
                    'city',
                    'Kota / Kabupaten',
                    'fas fa-city',
                    city,
                    handleCityChange,
                    province ? 'Pilih kota / kabupaten' : 'Pilih provinsi terlebih dahulu',
                    cityData,
                    !province
                  )}

                  {selectField(
                    'district',
                    'Kecamatan',
                    'fas fa-map-marker-alt',
                    district,
                    handleDistrictChange,
                    city ? 'Pilih kecamatan' : 'Pilih kota terlebih dahulu',
                    kecamatans,
                    !city
                  )}

                  {selectField(
                    'village',
                    'Desa / Kelurahan',
                    'fas fa-home',
                    village,
                    (e) => setVillage(e.target.value),
                    district ? 'Pilih desa / kelurahan' : 'Pilih kecamatan terlebih dahulu',
                    desas,
                    !district
                  )}

                  {field(
                    'shippingAddress',
                    'Alamat Lengkap (Jalan, RT/RW, No. Rumah)',
                    'fas fa-location-arrow',
                    <input
                      id="shippingAddress"
                      type="text"
                      className="auth-input"
                      placeholder="Contoh: Jl. Raya Menganti No. 38, Babatan, Wiyung"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />,
                    true,
                    'auth-grid-full'
                  )}
                </div>

                <button type="submit" disabled={load} className="btn-auth-submit mt-4">
                  {load ? (
                    <React.Fragment>
                      <i className="fas fa-spinner fa-spin mr-2" />
                      <span>Memproses Pendaftaran...</span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <i className="fas fa-user-check mr-2" />
                      <span>Selesaikan Pendaftaran</span>
                    </React.Fragment>
                  )}
                </button>

                <div className="auth-divider">
                  <span>atau</span>
                </div>

                <p className="auth-footer-prompt">
                  Sudah memiliki akun?
                  <Link to="/account/login" className="auth-link-bold">
                    Masuk di Sini
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

